export function percentageColorClass(percentage: number | undefined): string {
  if (percentage === undefined || percentage === 0) {
    return "empty";
  } else if (percentage < 30) {
    return "low";
  } else if (percentage < 100) {
    return "mid";
  } else {
    return "high";
  }
}
